var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNinjaBlueLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9796 87.1019C44.134 80.3957 36.8542 73.2002 31.48 68.2455L37.8681 23.3333C44.4128 29.3671 65.9559 62.4986 73.0543 71.1177C76.4851 75.2834 79.9747 79.9977 82.0781 84.4352C83.0436 86.4721 84.4469 89.9116 84.4377 94.034C84.4326 96.3 83.9983 99.3255 82.3197 102.45C80.56 105.726 77.9773 108.092 75.2477 109.577C72.3802 111.136 69.4516 111.999 66.8936 112.502C67.7136 113.298 68.621 114.128 69.6213 114.99C75.0263 119.647 81.3961 123.788 86.8472 127.315C90.1624 129.459 98.7025 133.48 109.076 137.959C119.065 142.272 129.712 146.572 136.442 149.204L129.406 163.428L99.5355 156.82L77.0813 150.044L63.1125 143.786C63.1125 143.786 58.4995 142.5 51.791 136.72C45.3813 131.197 37.7181 123.205 35.068 112.978C33.7849 108.027 33.0865 99.3798 40.0355 92.4984C42.8878 89.6738 46.0146 88.3074 48.2163 87.5976C48.8138 87.405 49.4043 87.2415 49.9796 87.1019ZM58.4245 98.6655C58.4245 98.6655 58.4132 98.6213 58.3742 98.5271C58.4023 98.6175 58.4245 98.6655 58.4245 98.6655ZM60.4984 103.526C60.4984 103.526 60.5007 103.544 60.5093 103.583C60.5034 103.546 60.4984 103.526 60.4984 103.526Z",
    fill: "url(#paint0_linear_475_569)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9187 167.863C41.3467 166.145 31.3012 164.684 24.0796 163.816L5 135C13.7943 136.057 49.9684 147.335 60.6365 149.7C65.7926 150.844 71.2968 152.287 75.4836 154.095C77.4054 154.925 80.4595 156.412 82.6966 158.838C83.9263 160.171 85.2081 162.114 85.4969 164.588C85.7997 167.181 84.9143 169.553 83.4252 171.463C81.8608 173.469 79.8654 175.089 77.9863 176.357C79.1099 176.513 80.3258 176.656 81.6371 176.782C88.7222 177.463 96.3387 177.475 102.847 177.475C106.805 177.475 116.183 176.592 127.353 175.28C138.11 174.017 149.412 172.496 156.511 171.485L158.333 182.516L129.593 189.988L107.004 194.542L91.8393 196.175C91.8393 196.175 87.256 197.172 78.4622 196.326C70.0601 195.518 59.258 193.735 51.4584 188.734C47.6822 186.313 42.3857 181.498 44.4874 174.813C45.3501 172.069 47.2378 170.078 48.7045 168.824C49.1025 168.484 49.5105 168.163 49.9187 167.863ZM63.3236 171.447C63.3236 171.447 63.2899 171.425 63.2059 171.385C63.2787 171.427 63.3236 171.447 63.3236 171.447ZM67.7157 173.514C67.7157 173.514 67.7278 173.524 67.7563 173.544C67.7307 173.524 67.7157 173.514 67.7157 173.514Z",
    fill: "url(#paint1_linear_475_569)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M315 178.333C315 237.244 267.244 298.333 208.334 298.333C149.423 298.333 101.667 237.244 101.667 178.333C101.667 119.423 149.423 90 208.334 90C267.244 90 315 119.423 315 178.333Z",
    fill: "url(#paint2_linear_475_569)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M315 178.333C315 237.244 267.244 298.333 208.334 298.333C149.423 298.333 101.667 237.244 101.667 178.333C101.667 119.423 149.423 90 208.334 90C267.244 90 315 119.423 315 178.333Z",
    fill: "url(#paint3_linear_475_569)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.345 244.132C119.049 225.182 111.084 202.044 111.084 179.269C111.084 126.475 153.882 100.107 206.676 100.107C239.57 100.107 268.584 110.344 285.782 130.83C269.46 106.359 238.145 94.1328 202.195 94.1328C149.401 94.1328 106.604 120.501 106.604 173.295C106.604 198.524 116.377 224.199 132.345 244.132Z",
    fill: "#A5A9AB",
    fillOpacity: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M296.666 173.365C296.666 210.951 252.848 248.333 207.5 248.333C162.151 248.333 118.333 210.951 118.333 173.365C118.333 135.778 162.151 144.122 207.5 144.122C252.848 144.122 296.666 135.778 296.666 173.365Z",
    fill: "url(#paint4_linear_475_569)",
    fillOpacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_475_569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.02 179.441C280.961 190.598 270.935 201.661 256.625 204.151C242.315 206.641 229.14 199.615 227.199 188.458C225.258 177.301 233.548 174.332 247.858 171.842C262.168 169.352 277.079 168.284 279.02 179.441Z",
    fill: "#0CC5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.182 179.441C133.241 190.598 143.267 201.661 157.577 204.151C171.887 206.641 185.062 199.615 187.003 188.458C188.944 177.301 180.655 174.332 166.345 171.842C152.035 169.352 137.123 168.284 135.182 179.441Z",
    fill: "#0CC5FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_475_569",
    x: 131.941,
    y: 169.209,
    width: 150.319,
    height: 40.4429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.772549 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_475_569"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_475_569",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_475_569",
    x1: 123.333,
    y1: 170,
    x2: -16.6667,
    y2: 93.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223958,
    stopColor: "#777E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#8E9496",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_475_569",
    x1: 123.333,
    y1: 170,
    x2: -16.6667,
    y2: 93.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223958,
    stopColor: "#777E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#8E9496",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_475_569",
    x1: 315,
    y1: 225,
    x2: 101.667,
    y2: 166.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.223958,
    stopColor: "#140716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D5970"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_475_569",
    x1: 315,
    y1: 225,
    x2: 118.334,
    y2: 133.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060809"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#11181B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#1D282D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651042,
    stopColor: "#4A5357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E9496"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_475_569",
    x1: 187.586,
    y1: 143.059,
    x2: 210.042,
    y2: 250.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.223958,
    stopColor: "#7DA2B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91A1A7",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNinjaBlueLogoIcon);
export default __webpack_public_path__ + "static/media/ninja-blue-logo-icon.9f45dd1ceb860dbd07319f587d145234.svg";
export { ForwardRef as ReactComponent };